import { FaEye, FaEyeSlash, FaCheckCircle } from "react-icons/fa";
import { ImSpinner2 } from "react-icons/im";
import { IoMdCloseCircle } from "react-icons/io";

const iconMap = {
  eye: FaEye,
  eyeSlash: FaEyeSlash,
  check: FaCheckCircle,
  closeCircle: IoMdCloseCircle,
  spinner: ImSpinner2
};

const Icon = ({ icon, size, ...props }) => {

  if (iconMap[icon] !== undefined) {
    const Icon = iconMap[icon];
    return <Icon style={{ fontSize: size }} {...props} />;
  } else {
    return (<></>);
  }
};

export default Icon;
